// extracted by mini-css-extract-plugin
module.exports = {"notification":"index-notification-2IdVn","icon":"index-icon-W0TqN"};